import styled from "styled-components";
import { motion } from "framer-motion";

export const Nav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1100;
  display: flex;
  justify-content: center;
  padding: ${({ $scrolled }) => ($scrolled ? "10px 20px" : "22px 20px")};
  background: ${({ $scrolled }) => ($scrolled ? "rgba(5, 5, 7, 0.72)" : "transparent")};
  backdrop-filter: ${({ $scrolled }) => ($scrolled ? "blur(16px)" : "none")};
  -webkit-backdrop-filter: ${({ $scrolled }) => ($scrolled ? "blur(16px)" : "none")};
  border-bottom: 1px solid ${({ $scrolled }) => ($scrolled ? "rgba(255,255,255,0.08)" : "transparent")};
  transition: padding 0.35s ease, background 0.35s ease, border-color 0.35s ease;
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1240px;
`;

export const LogoLink = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  cursor: pointer;
`;

export const LogoMark = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.gradient};
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  font-size: 17px;
  color: #050507;
  flex-shrink: 0;
`;

export const LogoText = styled.span`
  font-family: "Space Grotesk", sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  letter-spacing: -0.01em;

  @media (max-width: 480px) {
    display: none;
  }
`;

export const NavItems = styled.ul`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.07);
  list-style: none;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const NavLinkItem = styled.li`
  position: relative;
`;

export const NavLink = styled.a`
  position: relative;
  display: block;
  padding: 8px 16px;
  color: ${({ $active, theme }) => ($active ? theme.text_primary : theme.text_secondary)};
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  border-radius: 100px;
  transition: color 0.25s ease;
  z-index: 1;

  &:hover {
    color: ${({ theme }) => theme.text_primary};
  }
`;

export const NavPill = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 100px;
  z-index: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const IconLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: ${({ theme }) => theme.text_secondary};
  border: 1px solid rgba(255, 255, 255, 0.09);
  transition: all 0.25s ease;

  &:hover {
    color: ${({ theme }) => theme.text_primary};
    border-color: ${({ theme }) => theme.primary};
    transform: translateY(-2px);
  }
`;

export const ResumeButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 100px;
  background: ${({ theme }) => theme.gradient};
  color: #050507;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(139, 124, 255, 0.35);
  }
`;

export const MobileIcon = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: ${({ theme }) => theme.text_primary};
  width: 42px;
  height: 42px;
  border-radius: 12px;
  font-size: 1.1rem;
  cursor: pointer;

  @media screen and (max-width: 900px) {
    display: flex;
  }
`;

export const MobileMenu = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: 1150;
  background: rgba(5, 5, 7, 0.98);
  backdrop-filter: blur(20px);
  display: flex;
  flex-direction: column;
  padding: 90px 32px 40px;
`;

export const MobileTop = styled.div`
  position: fixed;
  top: 22px;
  right: 20px;
  z-index: 1200;
`;

export const MobileClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: ${({ theme }) => theme.text_primary};
  width: 42px;
  height: 42px;
  border-radius: 12px;
  font-size: 1.1rem;
  cursor: pointer;
`;

export const MobileLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 20px;
`;

export const MobileLink = styled(motion.a)`
  color: ${({ theme }) => theme.text_primary};
  font-family: "Space Grotesk", sans-serif;
  font-weight: 600;
  font-size: 32px;
  text-decoration: none;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`;

export const MobileFooter = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const MobileSocials = styled.div`
  display: flex;
  gap: 14px;
`;
